module.exports = __webpack_public_path__ + "img/404.1bdc1da7.png";